import Proptypes from 'prop-types';
import React, { useCallback, useState } from 'react'

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'twyne-new.ui';

import FormatterIcon from './FormatterIcon';

const propTypes = {
  icon: Proptypes.any,
  small: Proptypes.bool,
  tooltipText: Proptypes.string,
  id: Proptypes.string,
  children: Proptypes.node,
  style: Proptypes.any,
}

export default function DropDown({ contentProps, children, icon: Icon, tooltipText, small, style, open, ...props }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = useCallback(() => setDropdownOpen(prevState => !prevState), []);

  return <DropdownMenu darkMode open={dropdownOpen || open} onOpenChange={toggle} {...props}>
    <DropdownMenuTrigger>
      <FormatterIcon
        icon={Icon}
        tooltipText={tooltipText}
      />
    </DropdownMenuTrigger>
    <DropdownMenuContent {...contentProps} contentProps={{ className: 'bg-red-500!' }}>
      <DropdownMenuItem style={{ cursor: 'default' }} className={`${small && 'p-0'}`}>
        <div className="flex flex-wrap items-center justify-center w-full" style={style}>
          {children}
        </div>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
}

DropDown.propTypes = propTypes
DropDown.defaultProps = {
  small: false,
}
